/**
 * Station codes that render as one checkbox per utility (name must match API `code.name`).
 * Extend this map to add more split codes without changing page logic.
 */
export const SPLIT_STATION_UTILITIES = {
  HLTNW02: ["WATER", "SANITARY"],
};

const SEP = "\u001f";

export const baseSelectionKey = (codeId) => String(codeId);

export const utilitySelectionKey = (codeId, utility) =>
  `${codeId}${SEP}${utility}`;

export function utilitiesForStationCode(code) {
  const name = code?.name?.trim?.();
  const list = name ? SPLIT_STATION_UTILITIES[name] : null;
  return list ? [...list] : null;
}

export function toggleKeyInList(list, key) {
  return list.includes(key) ? list.filter((k) => k !== key) : [...list, key];
}

export function eligibleOfficeClearCodes(ticket) {
  return ticket?.code?.filter((c) => c.isOfficeClear) || [];
}

export function isStationRowFullySelected(code, selections) {
  const utils = utilitiesForStationCode(code);
  if (utils) {
    return utils.every((u) =>
      selections.includes(utilitySelectionKey(code.id, u))
    );
  }
  return selections.includes(baseSelectionKey(code.id));
}

/** Eligible rows with no selection (whole code → locate). Omits split rows at 1-of-N (handled elsewhere). */
export function unselectedStationCodeIdsForLocate(eligible, selections) {
  const ids = [];
  for (const code of eligible) {
    const utils = utilitiesForStationCode(code);
    if (utils) {
      const n = utils.filter((u) =>
        selections.includes(utilitySelectionKey(code.id, u))
      ).length;
      if (n === 0) ids.push(code.id);
    } else if (!selections.includes(baseSelectionKey(code.id))) {
      ids.push(code.id);
    }
  }
  return ids;
}

/** Station code ids processed via completeTicket + officeClearStation (normal path). */
export function stationIdsForStandardOfficeClear(eligible, selections) {
  const ids = [];
  for (const code of eligible) {
    const utils = utilitiesForStationCode(code);
    if (utils) {
      if (
        utils.every((u) =>
          selections.includes(utilitySelectionKey(code.id, u))
        )
      ) {
        ids.push(code.id);
      }
    } else if (selections.includes(baseSelectionKey(code.id))) {
      ids.push(code.id);
    }
  }
  return ids;
}

/** Split rows with exactly one utility selected → utility-office-clear + send to locate. */
export function splitPartialUtilitySelections(eligible, selections) {
  const out = [];
  for (const code of eligible) {
    const utils = utilitiesForStationCode(code);
    if (!utils) continue;
    const picked = utils.filter((u) =>
      selections.includes(utilitySelectionKey(code.id, u))
    );
    if (picked.length === 1) out.push({ code, utility: picked[0] });
  }
  return out;
}

export function allEligibleStationsSatisfied(eligible, selections) {
  return eligible.every((code) => isStationRowFullySelected(code, selections));
}
